module.exports = __webpack_public_path__ + "static/media/clue0202.57d1a020.jpg";